import { useState } from 'react'
import { useSelector } from 'react-redux'
import { CreatePortfolio } from '../components/CreatePortfolio'
import { selectIds } from '../store/slice/slice'
import { selectTypePortfolioSelect } from '../store/slice/sliceComponent'
import { GroupBtn } from './GroupBtn'
import { InteractiveTable } from './InteractiveTable'
import { Search } from './Search'

export const HeaderPortfoliosOverview = () => {
  const ids = useSelector(selectIds)
  const portfolioSelect = useSelector(selectTypePortfolioSelect)

  const [isShowCreateForm, setIsShowCreateForm] = useState(false)

  return (
    <div>
      <GroupBtn setIsShowCreateForm={setIsShowCreateForm} />
      <Search portfolioSelect={portfolioSelect} />
      <InteractiveTable ids={ids} typeSelect={portfolioSelect} />
      {isShowCreateForm && (
        <CreatePortfolio
          isShow={isShowCreateForm}
          setShow={setIsShowCreateForm}
        />
      )}
    </div>
  )
}
